import { css } from 'lit'
import { csColorBackground, csColorBorder, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const style = css`
  :host {
    display: block;
    box-sizing: border-box;
  }
  .property-fields {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    padding: ${csSpacing.spacing05} ${csSpacing.spacing06};
  }
  .property-groups {
    display: flex;
    flex-direction: column;
  }
  .property-group {
    border-bottom: ${csBorder.width} solid ${csColorBorder.light};
  }
  .property-group-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${csSpacing.spacing05};
    width: 100%;
    padding: 13px ${csSpacing.spacing06};
    border: none;
    background: transparent;
    color: ${csColorText.muted};
    text-align: left;
    cursor: pointer;
    transition: background-color 0.15s ease;
  }
  .property-group-toggle:hover {
    background: ${csColorBackground.secondary};
  }
  .property-group-title {
    --cse-text-color: ${csColorText.body};
    --cs-font-caption-s-font-size: 12px;
    --cs-font-caption-s-font-size-mobile: 12px;
    --cs-font-caption-s-font-weight: 600;
    --cs-font-caption-s-letter-spacing: 0.08em;
  }
  .property-group-toggle cse-icon {
    flex: none;
    font-size: 12px;
  }
  .property-group .property-fields {
    padding: ${csSpacing.spacing04} ${csSpacing.spacing06} ${csSpacing.spacing06};
  }
  .property-group .property-fields[hidden] {
    display: none;
  }
  /* Visibility is the "logic" tab — its active underline is orange, matching the tab's
     indicator dot, rather than the widget-blue the Settings tab uses (see panel-header.ts). */
  .panel-tab-visibility.active::after {
    background: ${csColorFunctional.warning};
  }
  .visibility-panel {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    padding: ${csSpacing.spacing06};
  }
  .visibility-rules {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
  }
  .visibility-rule-tooltip {
    display: block;
    --cs-font-caption-l-font-size: 12px;
    --cs-font-caption-l-font-size-mobile: 12px;
    --cs-font-caption-l-line-height: 1.3;
    --cse-tooltip-padding-y: ${csSpacing.spacing03};
    --cse-tooltip-padding-x: ${csSpacing.spacing04};
  }
  .visibility-rule-tooltip-text {
    display: block;
    max-width: 240px;
    white-space: normal;
  }
  .visibility-rule {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
    padding: 10px 12px;
    border: ${csBorder.width} solid color-mix(in srgb, ${csColorFunctional.warning} 35%, ${csColorBackground.primary});
    border-radius: ${csBorder.radiusMedium};
    background: ${csColorBackground.warning};
    position: relative;
  }
  .visibility-rule-header {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing04};
  }
  .visibility-condition-state,
  .visibility-built-in-state {
    flex: 1;
    min-width: 0;
  }
  .visibility-rule-remove,
  .visibility-built-in-lock {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    border: ${csBorder.width} solid color-mix(in srgb, ${csColorFunctional.warning} 35%, ${csColorBackground.primary});
    border-radius: 50%;
    background: ${csColorBackground.primary};
    color: ${csColorFunctional.warning};
    font-size: 12px;
  }
  .visibility-rule-remove {
    cursor: pointer;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
    transition: background-color 0.15s ease, color 0.15s ease;
  }
  .visibility-rule-remove:hover,
  .visibility-rule-remove:focus-visible {
    background: ${csColorFunctional.warning};
    color: ${csColorText.white};
  }
  .visibility-always {
    --cse-text-color: ${csColorText.muted};
  }
  .visibility-add-rule {
    align-self: flex-start;
    margin-top: 10px;
  }
`
